import { render, staticRenderFns } from "./DossierCreate.vue?vue&type=template&id=7251f84d&"
import script from "./DossierCreate.vue?vue&type=script&lang=js&"
export * from "./DossierCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports